// extracted by mini-css-extract-plugin
export default {"container":"Login_container__uoZZB","innerBox":"Login_innerBox__CMl+Q","footer":"Login_footer__i9Lkb","error":"Login_error__ZQVLu"};